import gql from 'graphql-tag'

export default gql`mutation ($data: ProjectExpenseInput!){
  upsertUserExpense(data: $data){
    id
      user_id
      user{
        full_name
      }
      project{
        project_id
        name
      }
      expense_at
      destination
      description
      expense_type
      expense_type_obj{
        id
        description
      }
      net
      vat
      gross
      created_at
      paid_at
      file_path
  }
}`